import { Skeleton } from 'primitives/skeleton'
import { TableCell, TableRow } from 'primitives/table'

interface SkeletonTableBodyProps {
  columnCount: number
  rowCount: number
  cellWidths?: string[]
  shrinkZero?: boolean
}

export const SkeletonTableBody = ({
  columnCount,
  rowCount,
  cellWidths,
  shrinkZero,
}: SkeletonTableBodyProps) => (
  <>
    {Array.from({ length: rowCount }).map((_, i) => (
      <TableRow key={i} className="hover:bg-transparent">
        {Array.from({ length: columnCount }).map((_, j) => (
          <TableCell
            key={j}
            style={{
              width: cellWidths?.[j],
              minWidth: shrinkZero ? cellWidths?.[j] : 'auto',
            }}
          >
            <Skeleton className="h-6 w-full" />
          </TableCell>
        ))}
      </TableRow>
    ))}
  </>
)
